// extracted by mini-css-extract-plugin
module.exports = {"reportHeader":"style__reportHeader__LU+OW","title":"style__title__4uAnN","date":"style__date__HYOti"};